import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Testimonials.css";
import { Box } from "@mui/material";
import { TestimonialCard } from "./TestimonialCard";
import { TESTIMONIALS } from "../../config/testimonials";

export const Testimonials = (props) => {
  return (
    <Box
      sx={{
        mt: { xs: 15, sm: 15, md: 15, lg: 15, xl: 15 },
        mb: { xs: 15, sm: 15, md: 15, lg: 15, xl: 15 },

        height: { xs: 300, sm: 420, md: 500, lg: 500, xl: 550 },
        width: "100%",
      }}
    >
      <Box
        sx={{
          m: "auto",
          width: {
            xs: "90%",
            sm: "80%",
            md: "70%",
            lg: "65%",
            xl: "50%",
          },
          height: "100%",
        }}
      >
        <Swiper
          navigation={true}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination, Navigation]}
          loop={true}
        >
          {TESTIMONIALS.map((content, index) => (
            <SwiperSlide key={index}>
              <TestimonialCard {...content} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
};
